'use client';
import { jsx } from 'react/jsx-runtime';
import { renderWithRef } from '../core/render-with-ref.js';
import { RenderComp } from '../core/render-comp.component.js';

function _object_without_properties(r, e) {
    if (null == r) return {};
    var o, t, n = _object_without_properties_loose(r, e);
    if (Object.getOwnPropertySymbols) {
        var i = Object.getOwnPropertySymbols(r);
        for(t = 0; t < i.length; t++)o = i[t], !(e.indexOf(o) >= 0) && Object.prototype.propertyIsEnumerable.call(r, o) && (n[o] = r[o]);
    }
    return n;
}
function _object_without_properties_loose(r, e) {
    if (null == r) return {};
    var o, t, n = {}, i = Object.keys(r);
    for(t = 0; t < i.length; t++)o = i[t], e.indexOf(o) >= 0 || (n[o] = r[o]);
    return n;
}
const ThumbnailsHeroBackgroundContainer = renderWithRef('ThumbnailsHeroBackgroundContainer', null, (o, t)=>{
    var { children: n } = o;
    return jsx(RenderComp, {
        root: "div",
        forwardedRef: t,
        classNames: [
            'swan-thumbnails-hero-background-container'
        ],
        props: _object_without_properties(o, [
            "children"
        ]),
        children: n
    });
});

export { ThumbnailsHeroBackgroundContainer };
